module.exports = __webpack_public_path__ + "static/bg-head-0ca16e10ae901e2257155c09dd79c3dd.png";